var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fleet-status"},_vm._l((_vm.fleetStatus),function(status){return _c('div',{staticClass:"fleet-status__item"},[_c('span',{staticClass:"fleet-status__indicator",style:({ backgroundColor: status.color })}),_c('span',{staticClass:"fleet-status__name"},[_vm._v(_vm._s(status.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }